<div class="w-100 container">
  <!-- ? Header -->
  <app-makna-header
    [title]="'ثبت نام'"
    [backUrl]="'login'"
  />

  <app-stepper
    class="w-100 mt-big"
    [activeStep]="activeStep"
  ></app-stepper>

  <!-- ? step content -->
  <div class="content-container w-100">
    <div class="content">
      @switch (activeStep) {
        <!-- ? Insert phoneNumber and OTP -->
        @case (1) {
          <!-- ? phoneNumber -->
          @if (!inOTPStep) {
            <p class="title-insert-phone">شماره موبایل خود را وارد کنید.</p>

            <div [formGroup]="phoneNumberForm">
              <ui-form-field
                label="شماره موبایل"
                [isNumericKeyboard]="true"
                [maxSize]="11"
                formControlName="cellNumber"
                [hasCleaner]="true"
                [convertNonEnglishDigits]="true"
                (ngModelChange)="phoneNumberChanged()"
              ></ui-form-field>
              @if (
                phoneNumberForm.controls['cellNumber'].value.length === 11 &&
                phoneNumberForm.controls['cellNumber'].dirty &&
                phoneNumberForm.controls['cellNumber'].hasError('pattern')
              ) {
                <div class="national-id-error">
                  <span>{{ phoneNumberInvalidErrorMessage }}</span>
                </div>
              }
            </div>
          } @else {
            <p class="title-insert-phone">کد ارسال شده به {{ phoneNumberForm.get('cellNumber')?.value }} را وارد کنید.</p>

            <app-pin-input
              [type]="'OTP'"
              [hasError]="otpHasError"
              [value]="this.otpCode"
              (pinChange)="pinChanged($event)"
              (onRemove)="pinChanged($event)"
            />
            @if (otpHasError) {
              <div class="otp-error">
                <span>{{ otpErrorInfo?.title }}</span>
              </div>
            }
          }
        }
        <!-- ? Insert nationalID -->
        @case (2) {
          <p class="title-insert-phone">کد ملی خود را وارد کنید.</p>

          <div [formGroup]="nationalIdForm">
            <ui-form-field
              label="کد ملی"
              [isNumericKeyboard]="true"
              [maxSize]="10"
              formControlName="nationalCode"
              [hasCleaner]="true"
              (ngModelChange)="nationalIdChanged()"
            ></ui-form-field>
            @if (nationalIdForm.controls['nationalCode'].value.length === 10 && nationalIdForm.invalid) {
              <div class="national-id-error">
                <span>{{ nationalCodeErrorMessage }}</span>
              </div>
            } @else if (nationalIdForm.controls['nationalCode'].value.length === 10 && nationalIdNotMatchError) {
              <div class="national-id-error">
                <span>این کد ملی متعلق به شماره موبایل وارد شده نیست</span>
              </div>
            }
          </div>
        }
        <!-- ? Generate Password -->
        @case (3) {
          <p class="title-insert-phone">برای حساب کاربری خود رمز عبور بسازید:</p>

          <app-password-complexity
            (onPasswordChanged)="onPasswordChanged($event)"
            (onRepeatPasswordChanged)="onRepeatPasswordChanged($event)"
          />
        }
      }
    </div>

    <div class="footer">
      <!-- ? Phone number and OTP -->
      @if (activeStep === _activeStep.InsertPhoneNumber) {
        @if (!inOTPStep) {
          <p class="has-account">
            قبلا ثبت نام کرده‌اید؟
            <span
              class="login cursor-pointer"
              (click)="onNextStep('LOGIN')"
            >
              ورود
            </span>
          </p>

          <ngx-button
            [style]="'fill'"
            [brandButton]="true"
            size="medium"
            [fullWidth]="true"
            [disabled]="phoneNumberForm.invalid || loading"
            (clickHandler)="onNextStep('GET_OTP')"
          >
            تایید و ادامه
          </ngx-button>
        } @else {
          <div class="button-container">
            <!-- ? Timer -->
            <ngx-button
              [style]="'tinted-on-elevated'"
              [fullWidth]="true"
              size="medium"
              [disabled]="!timeIsOver"
              (clickHandler)="onNextStep('GET_OTP')"
            >
              @if (!timeIsOver) {
                <ngx-count-down
                  [timeInSeconds]="otpSecounds"
                  [type]="'mm:ss'"
                  (finished)="timerFinish()"
                ></ngx-count-down>
              } @else {
                <span class="send-again">ارسال دوباره کد</span>
              }
            </ngx-button>

            <!-- ? Continue -->
            <ngx-button
              [style]="'fill'"
              [fullWidth]="true"
              size="medium"
              [brandButton]="true"
              [classNames]="['red']"
              (clickHandler)="onNextStep('GET_NATIONAL_ID')"
              [disabled]="otpCode?.length < 5 || otpHasError || loading || rateLimit || expireOtp"
            >
              ادامه
            </ngx-button>
          </div>
        }
      } @else if (activeStep === _activeStep.InsertNationalID) {
        <ngx-button
          [style]="'fill'"
          [brandButton]="true"
          size="medium"
          [fullWidth]="true"
          [disabled]="nationalIdForm.invalid || loading || !timeIsOver"
          (clickHandler)="onNextStep('CREATE_PASSWORD')"
        >
          @if (rateLimit) {
            <ngx-count-down
              [timeInSeconds]="otpSecounds"
              [type]="'mm:ss'"
              (finished)="timerFinish()"
            ></ngx-count-down>
          } @else {
            <span class="send-again"> تایید و ادامه </span>
          }
        </ngx-button>
      } @else if (activeStep === _activeStep.InsertPassword) {
        <ngx-button
          [style]="'fill'"
          [brandButton]="true"
          size="medium"
          [fullWidth]="true"
          [disabled]="password?.value?.length < 8 || passwordRepeat?.value?.length < 8 || loading"
          (clickHandler)="onNextStep('REGISTER_USER')"
        >
          @if (rateLimit) {
            <ngx-count-down
              [timeInSeconds]="otpSecounds"
              [type]="'mm:ss'"
              (finished)="timerFinish()"
            ></ngx-count-down>
          } @else {
            <span class="send-again"> ثبت نام </span>
          }
        </ngx-button>
      }
    </div>
  </div>
</div>
